import '@testing-library/jest-dom';
import { render, screen } from '@testing-library/react';

import { Backdrop } from './Backdrop';

describe('Backdrop', () => {
  it('should render', () => {
    render(<Backdrop>Backdrop overlay</Backdrop>);
    expect(screen.getByText('Backdrop overlay')).toBeInTheDocument();
  });
});
